import React from 'react';
import { useTranslation } from 'react-i18next';

const SOURCES = [
  'SPF Verification', 'DKIM Verification', 'DMARC Verification',
  'Sender WHOIS', 'Sender DNS', 'Sender IP Reputation',
  'Email Blocklists', 'Content Analysis', 'Entity Extraction',
  'URL Verification', 'Crypto Wallet Check', 'Modus Operandi',
  'Email Correlation', 'Community Intel', 'PhishTank', 'Similarity Check',
  'Spam Signatures DB', 'Scam Databases', 'Have I Been Pwned',
  'URL Deep Analysis', 'Brand Impersonation', 'Header Forensics',
  'Behavioral Analysis', 'Attachment Analysis', 'Domain Email Discovery',
  'Legitimacy Check', 'Grammar Analysis', 'Content Deep Analysis',
  'IOC Database (Local)',
  'Shodan InternetDB', 'EmailRep.io', 'abuse.ch (URLhaus + ThreatFox)',
  'IPQualityScore', 'NumVerify (Phone Check)',
];

export default function AnalysisProgress({ completed, total }) {
  const { t } = useTranslation();
  const percent = Math.round((completed / total) * 100);

  return (
    <div className="max-w-2xl mx-auto">
      <div className="glass-card p-8 text-center">
        {/* Spinner */}
        <div className="relative w-24 h-24 mx-auto mb-6">
          <svg className="animate-spin w-24 h-24" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="42" fill="none" stroke="#334155" strokeWidth="6" />
            <circle
              cx="50" cy="50" r="42" fill="none" stroke="#00d4aa" strokeWidth="6"
              strokeLinecap="round"
              strokeDasharray={264}
              strokeDashoffset={264 - (percent / 100) * 264}
              className="transition-all duration-500"
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-2xl font-bold text-white font-mono">{completed}</span>
            <span className="text-sm text-gray-400">/{total}</span>
          </div>
        </div>

        <h2 className="text-xl font-semibold text-white mb-2">{t('progress.title')}...</h2>
        <p className="text-gray-400 mb-6">
          {t('progress.sources', { completed, total })}
        </p>

        {/* Source list */}
        <div className="grid grid-cols-2 gap-2 text-left">
          {SOURCES.map((source, i) => (
            <div key={source} className="flex items-center gap-2 text-sm">
              {i < completed ? (
                <svg className="w-4 h-4 text-safe flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
              ) : i === completed ? (
                <svg className="w-4 h-4 text-caution animate-spin flex-shrink-0" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="3" strokeDasharray="30 60" />
                </svg>
              ) : (
                <div className="w-4 h-4 rounded-full border border-dark-border flex-shrink-0" />
              )}
              <span className={i < completed ? 'text-gray-300' : i === completed ? 'text-caution' : 'text-gray-500'}>
                {source}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
